import {combineReducers} from 'redux'
import jobBoards from './jobBoards'
import types from 'actions/types'

export const isSavingJobCard = (state = false, action) => {
  switch (action.type) {
    case types.PRODUCTION_UPDATE_JOB_CARD_ATTEMPT:
      return true
    case types.PRODUCTION_UPDATE_JOB_CARD_SUCCESS:
    case types.PRODUCTION_UPDATE_JOB_CARD_FAILURE:
      return false
    default:
      return state
  }
}

export default combineReducers({
  jobBoards,
  isSavingJobCard,
})
